import { Route, Routes } from "react-router-dom";
import ErrorPage from "./pages/ErrorPage";
// import LoadingPage from "./pages/LoadingPage";
import SignInPage from "./pages/SignInPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import HomePageOne from "./pages/HomePageOne";
import PlantationTablePage from "./pages/PlantationTablePage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import ComplainForm from "./pages/ComplainForm";
import ComplainFormUpdate from "./pages/ComplainFormUpdate";
import ComplainFormStatusUpdate from "./pages/ComplainFormStatusUpdate";
import TableDataPageDfos from "./pages/TableDataPageDfos";
import TableDataPageVolunteers from "./pages/TableDataPageVolunteers";
import SignUpPage from "./pages/SignUpPage";
// import MarketplaceDetailsPage from "./pages/MarketplaceDetailsPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import { ToastContainer } from 'react-toastify';
import ProtectedRoute from "./AuthContext/ProtectedRoute";
import React from "react";
import CustomRescuersForm from "./pages/CustomRescuersForm";
import CustomRescuersFormUpdate from "./pages/CustomRescuersFormUpdate";
import CustomRescuersTable from "./pages/CustomRescuersTable";
import UsersList from "./pages/UsersList";
import UserUpdatePage from "./pages/UserUpdatePage";
import DfoUpdatePage from "./pages/DfoUpdatePage";
import ProtectedComponent from "./AuthContext/PermissionWrapper";
import TableDataPageDispatch from "./pages/TableDataPageDispatch";
import ComplainFormDispatchUpdate from "./pages/ComplainFormDispatchUpdate";
// import ReportPerformance from "./pages/ReportPerformance";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import PlantationPageView from "./pages/PlantationPageView";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import PlantationPDFPage from "./pages/PlantationPDFPage";
import ReportActivity from "./pages/ReportActivity";
import ReportDistrict from "./pages/ReportDistrict";
import PlantYourActivityTablePage from "./pages/PlantYourActivityTablePage";
import PlantArrayActivityTablePage from "./pages/PlantArrayActivityTablePage";
import PlantDepActivityTablePage from "./pages/PlantDepActivityTablePage";
import PlantAssistant from './AI/PlantAssistant';
import ContactUsPage from "./pages/ContactUsPage";
import ProvisionalActivityPage from "./pages/ProvisionalActivityPage";

function App() {

  return (
    <React.Fragment>
      <RouteScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/sign-in" element={<SignInPage />} />
        <Route exact path="/access-denied" element={<AccessDeniedPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        {/* <Route path="/public-form" element={<StandAloneComplainForm />} /> */}
        <Route path="/" element={<SignInPage />} />
        <Route path="/plantation/pdf/:id" element={<PlantationPDFPage />} />


        {/* Protected Routes */}
        <Route
          element={
            <>
              <PlantAssistant />
              <ProtectedRoute />
            </>
          }
        >

          {/* Complaints Routes */}
          <Route path="/complains/add" element={
            <ProtectedComponent module="complaints" action="create">
              <ComplainForm />
            </ProtectedComponent>
          } />
          <Route path="/complains/update/:id" element={
            <ProtectedComponent module="complaints" action="edit">
              <ComplainFormUpdate />
            </ProtectedComponent>
          } />
          <Route path="/complains/update-status/:id" element={
            <ProtectedComponent module="complaints" action="update_status">
              <ComplainFormStatusUpdate />
            </ProtectedComponent>
          } />

          <Route path="/plantations/list" element={
            <ProtectedComponent module="plantations" action="view">
              <PlantationTablePage />
            </ProtectedComponent>
          } />
          {/* <Route path="/plant/virtual-assistant" element={
            <ProtectedComponent module="plant_va" action="view">
              <MarketplaceDetailsPage />
            </ProtectedComponent>
          } /> */}

          <Route path="/plantations/your-activity" element={
            <ProtectedComponent module="your_activity" action="view">
              <PlantYourActivityTablePage />
            </ProtectedComponent>
          } />

          <Route path="/plantations/array-activity" element={
            <ProtectedComponent module="array_activity" action="view">
              <PlantArrayActivityTablePage />
            </ProtectedComponent>
          } />

          <Route path="/plantations/departmental-activity" element={
            <ProtectedComponent module="dep_activity" action="view">
              <PlantDepActivityTablePage />
            </ProtectedComponent>
          } />

          <Route path="/plantations/provisional-activity" element={
            <ProtectedComponent module="provisional_activity" action="view">
              <ProvisionalActivityPage />
            </ProtectedComponent>
          } />

          <Route path="/plantation/view/:id" element={
            <ProtectedComponent module="plantations" action="view">
              <PlantationPageView />
            </ProtectedComponent>
          } />

          <Route path="/dispatch/list" element={
            <ProtectedComponent module="lead_dispatch" action="view">
              <TableDataPageDispatch />
            </ProtectedComponent>
          } />

          <Route path="/dispatch/update/:id" element={
            <ProtectedComponent module="lead_dispatch" action="dispatch">
              <ComplainFormDispatchUpdate />
            </ProtectedComponent>
          } />
          {/* Users Routes */}
          <Route path="/users/add" element={
            <ProtectedComponent module="users" action="create">
              <SignUpPage />
            </ProtectedComponent>
          } />
          <Route path="/users/update/:id" element={
            <ProtectedComponent module="users" action="edit">
              <UserUpdatePage />
            </ProtectedComponent>
          } />
          <Route path="/users/list" element={
            <ProtectedComponent module="users" action="view">
              <UsersList />
            </ProtectedComponent>
          } />

          {/* Dashboard */}
          <Route path="/dashboard" element={
            <ProtectedComponent module="dashboard" action="view">
              <HomePageOne />
            </ProtectedComponent>
          } />

          {/* DFOs List */}
          <Route path="/dfos-list" element={
            <ProtectedComponent module="dfo_list" action="view">
              <TableDataPageDfos />
            </ProtectedComponent>
          } />
          {/* DFOs List */}
          <Route path="/volunteer-list" element={
            <ProtectedComponent module="dashboard-volunteer" action="view">
              <TableDataPageVolunteers />
            </ProtectedComponent>
          } />
          <Route path="/dfos/update/:id" element={
            <ProtectedComponent module="dfo_list" action="edit">
              <DfoUpdatePage />
            </ProtectedComponent>
          } />
          {/* Rescuers Routes */}
          <Route path="/rescures/add" element={
            <ProtectedComponent module="rescuers" action="create">
              <CustomRescuersForm />
            </ProtectedComponent>
          } />
          <Route path="/rescuers/update/:id" element={
            <ProtectedComponent module="rescuers" action="edit">
              <CustomRescuersFormUpdate />
            </ProtectedComponent>
          } />
          <Route path="/rescures/list" element={
            <ProtectedComponent module="rescuers" action="view">
              <CustomRescuersTable />
            </ProtectedComponent>
          } />

          {/* Reports Routes */}
          <Route path="/reports/activity" element={
            <ProtectedComponent module="reports" action="view">
              <ReportActivity />
            </ProtectedComponent>
          } />
          <Route path="/reports/district-wise" element={
            <ProtectedComponent module="reports" action="view">
              <ReportDistrict />
            </ProtectedComponent>
          } />

          {/* Common Routes */}
          <Route path="/change-password" element={<ViewProfilePage />} />
          {/* Common Routes */}
          <Route path="/contact-us" element={<ContactUsPage />} />
        </Route>

        {/* Catch-All Route */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>

      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} closeOnClick pauseOnHover draggable />
    </React.Fragment>
  );
}

export default App;
